import { render, staticRenderFns } from "./OrderDiscountBreakdown.vue?vue&type=template&id=11362bc4&"
import script from "./OrderDiscountBreakdown.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports